@if (props.class) {
  <div [ngClass]="'alert ' + props.class">
    {{ props.label }}
  </div>
}

@if (!props.class) {
  <br><h6>{{ props.label }}</h6>
}
